import Icon from "@ant-design/icons";
import styled from "styled-components";
import { ButtonUpvoteAntd } from "../buttonUpvote/buttonUpvote.style";

export const ButtonCommentAntd = styled(ButtonUpvoteAntd)``;

export const ButtonIconAntd = styled(Icon)``;
